import { Box, Flex, Heading, Text } from '@chakra-ui/react';

import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';
import { Section } from '~/components/section';

import { MentorBenefitsCard } from './mentor-benefits-card';
import { MentorRoleTabs, MentorRoleTabsProps } from './mentor-role-tabs';

type MentorRolesSectionProps = {
  title: string;
  description: string;
  benefitsTitle: string;
  roles: MentorRoleTabsProps['roles'];
  benefits: {
    title: string;
    description: string;
  }[];
};

export function MentorRolesSection({ title, description, roles, benefits, benefitsTitle }: MentorRolesSectionProps) {
  return (
    <Section bgColor='gray.50' id='mentor-roles'>
      <Flex flexDirection='column' textAlign='center'>
        <Box marginBottom='40px'>
          {title && (
            <HeadingWithEmphasis
              text={title}
              emphasisProps={{
                color: 'blue.500',
                fontWeight: '500',
              }}
              headingProps={{
                size: 'marketing-5xl',
                as: 'h2',
                marginBottom: '10px',
              }}
            />
          )}
          {description && (
            <Text margin='auto' maxWidth='730px'>
              {description}
            </Text>
          )}
        </Box>

        <MentorRoleTabs roles={roles} />

        <Box>
          <Heading as='h2' marginBottom='32px' marginTop='80px' size='marketing-2xl'>
            {benefitsTitle}
          </Heading>
          <Flex
            flexWrap='wrap'
            gap='32px'
            justifyContent='center'
            flex={{
              lg: '0 0 calc(50% - 10px)',
            }}
          >
            {benefits?.map((benefit) => (
              <MentorBenefitsCard key={benefit.title} description={benefit.description} title={benefit.title} />
            ))}
          </Flex>
        </Box>
      </Flex>
    </Section>
  );
}
